<!--
 * Path: src/core/components/floatingPanel/FloatingPanelToolbar.vue
 * Task: Render a compact sub-menu toolbar for floating panels with translucent dark styles.
-->
<template>
  <div
    class="panel-menu px-2 py-1 d-flex align-center"
    style="gap: 4px; border-bottom: 1px solid rgba(255, 255, 255, 0.1); background-color: rgba(255, 255, 255, 0.03);"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/floatingPanel/FloatingPanelToolbar.vue
 * Task: Scaffolding wrapper.
 */
</script>
